import Dexie from 'dexie';

const db = new Dexie('GUIdatabase');
db.version(1).stores({
  compositions: '++id, value'
});
export default db;